import * as React from 'react';
import HourglassOutlined from './hourglass-outlined';
import HourglassFilled from './hourglass-filled';
import type { IconCombinedProps } from './types';
const HourglassCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <HourglassFilled ref={ref} {...rest} />;
  }
  return <HourglassOutlined ref={ref} {...rest} />;
});
export default HourglassCombined;